import { GET_TRANSACTIONS_CHARGES_TRAY, UPDATE_TRANSACTIONS_CHARGES_TRAY } from './../constants';
import { handleActions } from "redux-actions"

export const userCodesCharge  = handleActions(
  {
    [ GET_TRANSACTIONS_CHARGES_TRAY ]: (state, action) => [ ...action.payload ],
    [ UPDATE_TRANSACTIONS_CHARGES_TRAY ]: (state, action) => {
      const result  = action.payload
            const { sequence } = result
            const userCodes  = state
            const initialValue = []
            const newUserCode = userCodes.reduce((acc, user) => {
                if (user.sequence === sequence) {
                  // console.log(user.sequence +  ' con ' + sequence)
                    return [...acc, result]
                } else {
                    return [...acc, user]
                }
            }, initialValue)
            return newUserCode
    },
  }, []
)